/* eslint-disable no-unused-vars */
import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import AppTitle from './AppTitle';
import Container from '@material-ui/core/Container';
import UserMenu from '../Menus/UserMenu';
import NotificationsMenu from '../Menus/NotificationsMenu';
import LanguageMenu from '../Menus/LanguageMenu';
import { Box } from '@material-ui/core';
import useAppContext from '../../../../hooks/context/useAppContext';
import MainMenuContent from '../../../MenuContent/MainMenuContent';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#ffffff',
    color: theme.palette.primary.main,
  },
  toolbar: {
    backgroundColor: '#ffffff',
    color: theme.palette.primary.main,
  },
}));

const TopBar = () => {
  const classes = useStyles({});
  const { breadCrumbs } = useAppContext();
  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar>
        <AppTitle />
        <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <NotificationsMenu />
          <UserMenu />
          <Divider orientation="vertical" flexItem style={{ margin: '4px 8px' }} />
          <LanguageMenu />
        </Box>
      </Toolbar>
      <Toolbar className={classes.toolbar} disableGutters>
        <MainMenuContent />
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {};

export default TopBar;
